
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { RevModal } from '@ds/components/Modal'

import { MODAL_NAMES } from '@config/constants'
import SatisfactionModalContent from '@reassurance/components/SatisfactionModal/SatisfactionModalContent.vue'
import WarrantyModalContent from '@reassurance/components/WarrantyModal/WarrantyModalContent.vue'

import translations from './ReassuranceModal.translations'

export default {
  components: {
    RevDivider,
    RevModal,
    WarrantyModalContent,
    SatisfactionModalContent,
    RevIllustration,
  },

  computed: {
    name: () => MODAL_NAMES.PRODUCT.REASSURANCE,
    translations: () => translations,
  },
}
